module.exports = __webpack_public_path__ + "dj.svg?addb4ed520b75ff1f321258159e7fda8";